import classNames from 'classnames'
import { useState, type MouseEvent, type ReactNode } from 'react'
import { InfoIcon } from '../icons/InfoIcon'
import { Modal } from './Modal'
import styles from './Label.module.css'

interface LabelProps {
  htmlFor?: string
  info?: ReactNode
  infoTitle?: string
  children: ReactNode
  className?: string
}

export const Label = ({ htmlFor, info, infoTitle = 'Info', children, className }: LabelProps) => {
  const [open, setOpen] = useState(false)
  const [tooltipPosition, setTooltipPosition] = useState<{ x: number; y: number } | null>(null)

  const trackTooltip = (e: MouseEvent<HTMLButtonElement>) =>
    setTooltipPosition({ x: e.clientX, y: e.clientY })

  const inner = (
    <>
      {children}
      {info && (
        <button
          type="button"
          className={styles['infoButton']}
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            setOpen(true)
          }}
          onMouseEnter={trackTooltip}
          onMouseMove={trackTooltip}
          onMouseLeave={() => setTooltipPosition(null)}
          aria-label="Show info"
        >
          <InfoIcon className={styles['infoIcon']} />
        </button>
      )}
    </>
  )

  return (
    <>
      {htmlFor ? (
        <label htmlFor={htmlFor} className={classNames(styles['label'], className)}>
          {inner}
        </label>
      ) : (
        <span className={classNames(styles['label'], className)}>{inner}</span>
      )}
      {info && tooltipPosition && (
        <div
          className={styles['tooltip']}
          style={{ top: tooltipPosition.y + 10, left: tooltipPosition.x + 5 }}
        >
          {info}
        </div>
      )}
      {info && (
        <Modal open={open} title={infoTitle} onClose={() => setOpen(false)}>
          {info}
        </Modal>
      )}
    </>
  )
}
